import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueLazyload from 'vue-lazyload'
import vSelect from 'vue-select'

import 'vue-select/dist/vue-select.css';
import 'devextreme/dist/css/dx.light.css';
// import 'bootstrap/dist/css/bootstrap.css'
// import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js'
//.use(bootstrap)

import common from './assets/common.js'
createApp(App).use(router).use(store).use(common).use(VueLazyload).component("vSelect", vSelect).mount('#app')